import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-026acaa0")

_pushScopeId("data-v-026acaa0")
const _hoisted_1 = { class: "overlay-card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "event" }
const _hoisted_4 = { class: "overlay-name" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = {
  key: 0,
  icon: "check",
  style: {"color":"green"},
  scale: "s",
  title: "Active"
}
const _hoisted_7 = {
  key: 1,
  icon: "x",
  style: {"color":"red"},
  scale: "s",
  title: "Not active"
}
const _hoisted_8 = {
  key: 2,
  scale: "s",
  icon: "offline",
  title: "Not published"
}
const _hoisted_9 = {
  key: 3,
  scale: "s",
  icon: "refresh",
  title: "Pending"
}
const _hoisted_10 = {
  key: 4,
  scale: "s",
  icon: "online",
  style: {"color":"green"},
  title: "Published"
}
const _hoisted_11 = {
  key: 5,
  scale: "s",
  icon: "exclamation-mark-triangle-f",
  style: {"color":"red"},
  title: "Failed"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.overlay.Event), 1),
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.overlay.Name), 1),
      _createVNode("div", _hoisted_5, [
        (_ctx.overlay.Active)
          ? (_openBlock(), _createBlock("calcite-icon", _hoisted_6))
          : _createCommentVNode("", true),
        (!_ctx.overlay.Active)
          ? (_openBlock(), _createBlock("calcite-icon", _hoisted_7))
          : _createCommentVNode("", true),
        (!['1','2','3'].includes(_ctx.overlay.PublishedStatus))
          ? (_openBlock(), _createBlock("calcite-icon", _hoisted_8))
          : _createCommentVNode("", true),
        (_ctx.overlay.PublishedStatus === '1')
          ? (_openBlock(), _createBlock("calcite-icon", _hoisted_9))
          : _createCommentVNode("", true),
        (_ctx.overlay.PublishedStatus === '2')
          ? (_openBlock(), _createBlock("calcite-icon", _hoisted_10))
          : _createCommentVNode("", true),
        (_ctx.overlay.PublishedStatus === '3')
          ? (_openBlock(), _createBlock("calcite-icon", _hoisted_11))
          : _createCommentVNode("", true),
        (_ctx.isEditor)
          ? (_openBlock(), _createBlock("calcite-icon", {
              key: 6,
              icon: "pencil",
              onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.openOverlay && _ctx.openOverlay(...args))),
              scale: "s"
            }))
          : _createCommentVNode("", true),
        (!_ctx.isEditor)
          ? (_openBlock(), _createBlock("calcite-icon", {
              key: 7,
              icon: "view-visible",
              onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.openOverlay && _ctx.openOverlay(...args))),
              scale: "s"
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})